import React from 'react';
import { Modal, Button, IconSettings } from '@salesforce/design-system-react';

interface SessionExpiryModalProps {
    isOpen: boolean;
    onLogin: () => void;
}

/**
 * Session Expiry Modal Component
 * 
 * Displays a modal when the user's Salesforce session has expired.
 * The modal blocks all UI interactions and requires the user to log back in.
 */
function CQSessionExpiryModal({ isOpen, onLogin }: SessionExpiryModalProps) {
    return (
        <IconSettings iconPath="/assets/icons">
            <Modal
                isOpen={isOpen}
                heading="Session Expired"
                size="small"
                dismissOnClickOutside={false}
                footer={[
                    <Button
                        key="login"
                        label="Login"
                        variant="brand"
                        onClick={onLogin}
                    />
                ]}
            >
                <div className="slds-p-around_medium">
                    <p className="slds-text-body_regular">
                        Your session has expired. Please log in again to continue.
                    </p>
                </div>
            </Modal>
        </IconSettings>
    );
}

export default CQSessionExpiryModal;
